export const DevUtils = {
  computed: {
    isDevelopment () {
      return (process && process.env && process.env.NODE_ENV === 'development') || false;
    }
  }
};
